import React, { useState } from 'react'
import { LuReceipt, LuX, LuCircleCheck, LuMail, LuMessageSquare, LuDownload } from "react-icons/lu";
const RecurringPaymentReceiptPopup = ({ onClose, payment, planDescription }) => {
  const [sendSuccess, setSendSuccess] = useState(false);
  const [sendingMethod, setSendingMethod] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [recipientEmail, setRecipientEmail] = useState('john.doe@email.com');
  const [recipientPhone, setRecipientPhone] = useState('(555) 123-4567');



  const handleSendReceipt = async (method) => {
    setIsSending(true);
    setSendingMethod(method);
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    setIsSending(false);
    setSendSuccess(true);
    // Reset success state after 3 seconds
    setTimeout(() => {
      setSendSuccess(false);
      setSendingMethod(null);
    }, 3000);
  };

  const handleDownloadReceipt = () => {
    // In a real app, this would generate and download a PDF receipt
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gray-50">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-green-100 rounded-lg">
                <LuReceipt className="h-5 w-5 text-green-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Payment Receipt</h3>
                <p className="text-sm text-gray-500">Payment #{payment.paymentNumber}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
            >
              <LuX className="h-5 w-5 text-gray-500" />
            </button>
          </div>

          {/* Receipt Details */}
          <div className="p-6 space-y-4">
            <div className="bg-gray-50 rounded-lg p-4 space-y-3">
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Plan:</span>
                <span className="text-sm font-medium text-gray-900">{planDescription}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Payment Date:</span>
                <span className="text-sm font-medium text-gray-900">
                  {new Date(payment.paymentDate).toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Amount:</span>
                <span className="text-lg font-semibold text-gray-900">${payment.amount.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Transaction ID:</span>
                <span className="text-sm font-mono text-gray-900">{payment.stripePaymentIntentId}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Receipt ID:</span>
                <span className="text-sm font-mono text-gray-900">{payment.stripeReceiptNumber}</span>
              </div>
            </div>

            {/* Success Message */}
            {sendSuccess && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center">
                  <LuCircleCheck className="h-5 w-5 text-green-600 mr-3" />
                  <div>
                    <p className="text-sm font-medium text-green-800">
                      Receipt sent successfully!
                    </p>
                    <p className="text-sm text-green-700">
                      Receipt has been sent via {sendingMethod === 'email' ? 'email' : 'text message'}.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                {/* Send via Email */}
                <button
                  onClick={() => handleSendReceipt('email')}
                  disabled={isSending}
                  className="flex items-center justify-center px-4 py-3 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {isSending && sendingMethod === 'email' ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  ) : (
                    <LuMail className="h-4 w-4 mr-2" />
                  )}
                  Send Email
                </button>

                {/* Send via Text */}
                <button
                  onClick={() => handleSendReceipt('text')}
                  disabled={isSending}
                  className="flex items-center justify-center px-4 py-3 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {isSending && sendingMethod === 'text' ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  ) : (
                    <LuMessageSquare className="h-4 w-4 mr-2" />
                  )}
                  Send Text
                </button>
              </div>

              {/* Download Receipt */}
              <button
                onClick={handleDownloadReceipt}
                className="w-full flex items-center justify-center px-4 py-3 bg-gray-600 text-white text-sm font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
              >
                <LuDownload className="h-4 w-4 mr-2" />
                Download PDF
              </button>
            </div>

            {/* Contact Information */}
            <div className="space-y-3 pt-4 border-t border-gray-200">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address
                </label>
                <input
                  type="email"
                  value={recipientEmail}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone Number
                </label>
                <input
                  type="tel"
                  value={recipientPhone}
                  onChange={(e) => setRecipientPhone(e.target.value)}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecurringPaymentReceiptPopup